<!-- ========== MAIN CONTENT ========== -->
<main (resized)="onResized($any($event))" *ngIf="initialized" id="content" role="main">
  <!-- Hero Section -->
  <div id="SVGHero" class="position-relative bg-white overflow-hidden" style="">
    <div class="container position-relative z-index-2 space-top-2 space-bottom-3 space-top-md-2">
      <div class="row align-items-lg-center">
        <div class="col-lg-5 mb-11 mb-lg-0">
          <!-- Info -->
          <div class="mb-6">
            <h1 class="text-white font-weight-semi-bold mb-3">
              Simplifying the When,<br> Perfecting the How
              <span class="text-indigo">
                <strong class="u-text-animation u-text-animation--typing"></strong>
              </span>
              <br />
<!--              {{ 'ceu-events-and-courses' | translate }}-->
            </h1>
            <p class="text-white-70">More than a software platform, OkWhen is your complete solution for Conferences, Events, Webinars, AV Production, and CEU content sales!</p>
          </div>

          <!-- <a class="btn btn-white btn-wide btn-pill text-primary shadow-soft transition-3d-hover mb-2 mb-sm-0 mr-4" [routerLink]="['/products-services']">Products & Services</a> -->
          <button class="btn btn-primary btn-wide btn-pill transition-3d-hover mb-2 mb-sm-0" type="button" (click)="ctaService.showCTA('17e74dcb-2609-478e-848a-ceffdd2c4df2')">Book a Demo</button>
          <!-- End Info -->
        </div>

        <div class="col-lg-7">
          <div class="position-relative">
            <!-- SVG Laptop Mockup -->
            <figure class="ie-devices-v4-laptop mb-3 mb-sm-0">
              <img class="img-fluid" src="../../assets/website/laptop-graphic-5.png">
            </figure>
            <!-- SVG Laptop Mockup -->

            <!-- Card Info -->
<!--            <div class="position-sm-absolute bottom-0 right-0 max-width-40 ml-auto mb-sm-n5">-->
<!--              <div class="card border-0 bg-primary shadow-primary-lg rounded p-5">-->
<!--                <h2 class="h5 text-white font-weight-semi-bold mb-3">-->
<!--                  Simplifying the When,<br> Perfecting the How-->
<!--                </h2>-->
<!--                <p class="text-white">Schedule a demo today and see how we can elevate your next event!-->

<!--                </p>-->
<!--                <p class="font-size-1 font-weight-medium" style="color: #051d40">Our world-class marketing team can help you host a live event!</p>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>

    <!-- SVG Background Shape -->
    <div class="gradient-overlay-half-home-hero svg-divider-polygon position-absolute top-0 right-0 bottom-0 left-0">
      <figure class="ie-circles-hero"></figure>
    </div>
    <!-- End SVG Background Shape -->
  </div>

  <!-- Get Started Section -->
  <div class="container space-2">
    <div class="row mb-4 justify-content-md-between">
      <div class="col-sm-6 offset-sm-3 col-lg-4 offset-lg-0 mb-9 mb-lg-0">
        <!-- Icon Blocks -->
        <div class="text-center">
          <!-- SVG Icon -->
          <figure id="SVGcreateAccount" class="w-65 mx-auto mb-4">
            <img  class="img-fluid" src="../../assets/website/platform.png" alt="Image Description"
                 data-parent="#SVGcreateAccount">
          </figure>
          <!-- End SVG Icon -->

          <div class="mb-4">
            <h1 class="h5">Event Management Platform</h1>
            <p>Website, registration, mobile app, scheduler, task management, badge printing, messaging, surveys, call-for-papers, sponsor stores, asset management and much more</p>
          </div>
          <a class="btn btn-sm btn-soft-admin-primary btn-wide transition-3d-hover" [routerLink]="['event-software']">
            Learn More
            <span class="fas fa-angle-right ml-2"></span>
          </a>
        </div>
        <!-- End Icon Blocks -->
      </div>

      <div class="col-sm-6 col-lg-4 mb-9 mb-sm-0">
        <!-- Icon Blocks -->
        <div class="text-center">
          <!-- SVG Icon -->
          <figure id="SVGpostResume" class="w-65 mx-auto mb-4">
            <img class="img-fluid" src="../../assets/website/stage.png" alt="Image Description"
                 data-parent="#SVGpostResume">
          </figure>
          <!-- End SVG Icon -->

          <div class="mb-4">
            <h2 class="h5">Audio Visual & stage design</h2>
            <p>Projectors, microphones, audio engineering, video walls and stage design. Let our team bundle AV for a fraction of the cost of in-house vendors.</p>
          </div>
          <a class="btn btn-sm btn-soft-admin-primary btn-wide transition-3d-hover" [routerLink]="['av-services']">
            Learn More
            <span class="fas fa-angle-right ml-2"></span>
          </a>
        </div>
        <!-- End Icon Blocks -->
      </div>

      <div class="col-sm-6 col-lg-4">
        <!-- Icon Blocks -->
        <div class="text-center">
          <!-- SVG Icon -->
          <figure id="SVGportfolio" class=" w-65 mx-auto mb-4">
            <img class="img-fluid" src="../../assets/website/planning.png" alt="Image Description"
                 data-parent="#SVGportfolio">
          </figure>
          <!-- End SVG Icon -->

          <div class="mb-4">
            <h3 class="h5">Professional Planner Services</h3>
            <p>Hire one of our dedicated conference/event planners and let us handle venue collaboration, room blocks, food & beverage, vendors and much more!</p>
          </div>
          <a class="btn btn-sm btn-soft-admin-primary btn-wide transition-3d-hover" [routerLink]="['planning-services']">
            Learn More
            <span class="fas fa-angle-right ml-2"></span>
          </a>
        </div>
        <!-- End Icon Blocks -->
      </div>
    </div>
    <div class="row space-top-1 justify-content-md-between">
      <div class="col-sm-6 offset-sm-3 col-lg-4 offset-lg-0 mb-9 mb-lg-0">
        <!-- Icon Blocks -->
        <div class="text-center">
          <!-- SVG Icon -->
          <figure id="SVGcreateAccount" class="w-65 mx-auto mb-4">
            <img  class="img-fluid" src="../../assets/website/streaming.png" alt="Image Description"
                  data-parent="#SVGcreateAccount">
          </figure>
          <!-- End SVG Icon -->

          <div class="mb-4">
            <h1 class="h5">Hybrid Event Streaming</h1>
            <p>With our proprietary "streambox" combined with our software platform, we can cost-effectively live-stream up to 30 tracks.</p>
          </div>
          <a class="btn btn-sm btn-soft-admin-primary btn-wide transition-3d-hover" [routerLink]="['live-streaming']">
            Learn More
            <span class="fas fa-angle-right ml-2"></span>
          </a>
        </div>
        <!-- End Icon Blocks -->
      </div>

      <div class="col-sm-6 col-lg-4 mb-9 mb-sm-0">
        <!-- Icon Blocks -->
        <div class="text-center">
          <!-- SVG Icon -->
          <figure id="SVGpostResume" class="w-65 mx-auto mb-4">
            <img class="img-fluid" src="../../assets/website/av-rentals.png" alt="Image Description"
                 data-parent="#SVGpostResume">
          </figure>
          <!-- End SVG Icon -->

          <div class="mb-4">
            <h2 class="h5">Equipment Rentals</h2>
            <p>Rent our cameras, Tvs, screens, mixers, lighting, stage decor, furniture and more!</p>
          </div>
          <a class="btn btn-sm btn-soft-admin-primary btn-wide transition-3d-hover" href="#">
            Learn More
            <span class="fas fa-angle-right ml-2"></span>
          </a>
        </div>
        <!-- End Icon Blocks -->
      </div>

      <div class="col-sm-6 col-lg-4">
        <!-- Icon Blocks -->
        <div class="text-center">
          <!-- SVG Icon -->
          <figure id="SVGportfolio" class=" w-65 mx-auto mb-4">
            <img class="img-fluid" src="../../assets/website/site-selection.png" alt="Image Description"
                 data-parent="#SVGportfolio">
          </figure>
          <!-- End SVG Icon -->

          <div class="mb-4">
            <h3 class="h5">Venue Site Selection</h3>
            <p>We are an accredited IATA travel agent and can help you find your next conference venue and provide support during the contracting process!</p>
          </div>
          <a class="btn btn-sm btn-soft-admin-primary btn-wide transition-3d-hover" href="#">
            Learn More
            <span class="fas fa-angle-right ml-2"></span>
          </a>
        </div>
        <!-- End Icon Blocks -->
      </div>
    </div>
  </div>


  <!-- Features Section -->
  <div class="container space-2 space-top-lg-3">
    <div class="row justify-content-lg-between align-items-lg-center">
      <div class="col-lg-5 mb-9 mb-lg-0">
        <div class="mb-5">
          <h2 class="font-weight-medium mb-4">A Conference Companion In your Pocket</h2>
          <p>Take your conference engagement to the next level with our app, fostering collaboration and meaningful interactions.</p>
        </div>
        <ul class="list-unstyled">
          <li class="media align-items-center pt-3">
              <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-3">
                <span class="fas fa-check btn-icon__inner"></span>
              </span>
            <div class="media-body">
              <p class="text-dark mb-0">Attendee Chat</p>
            </div>
          </li>
          <li class="media align-items-center pt-3">
              <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-3">
                <span class="fas fa-check btn-icon__inner"></span>
              </span>
            <div class="media-body">
              <p class="text-dark mb-0">Conference Schedule</p>
            </div>
          </li>
          <li class="media align-items-center pt-3">
              <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-3">
                <span class="fas fa-check btn-icon__inner"></span>
              </span>
            <div class="media-body">
              <p class="text-dark mb-0">Sponsor Lead retrieval</p>
            </div>
          </li>
          <li class="media align-items-center pt-3">
              <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-3">
                <span class="fas fa-check btn-icon__inner"></span>
              </span>
            <div class="media-body">
              <p class="text-dark mb-0">Push Notifications</p>
            </div>
          </li>
          <li class="media align-items-center pt-3">
              <span class="btn btn-icon btn-sm btn-soft-indigo rounded-circle mr-3">
                <span class="fas fa-check btn-icon__inner"></span>
              </span>
            <div class="media-body">
              <p class="text-dark mb-0">Complete Customization</p>
            </div>
          </li>
        </ul>

      </div>

      <div class="col-lg-6">
        <div id="featuresSVG" class=" position-relative max-width-50 mx-auto">
          <!-- SVG Phone Mockup -->
          <div class="w-75 u-devices-v2__phone-svg shadow-sm mx-auto">
            <figure class="ie-iphone-x-1">
              <img class="img-fluid" src="../../assets/website/iphone-screenshot-1.png" alt="Image Description"
                   data-img-paths='[
                   {"targetId": "#SVGiphoneX1Img1", "newPath": "../../assets/website/iphone-screenshot-1.png"}
                 ]'
                   data-parent="#featuresSVG">
            </figure>
          </div>
          <!-- End SVG Phone Mockup -->

          <!-- SVG Component -->
          <div class="position-absolute bottom-0 right-0 max-width-50 w-100 z-index-n1 mx-auto">
            <figure class="ie-abstract-shapes-12">
              <img class="js-svg-injector" src="../../assets/svg/components/abstract-shapes-12.svg" alt="Image Description"
                   data-parent="#featuresSVG">
            </figure>
          </div>
          <!-- End SVG Component -->
        </div>
      </div>
    </div>
  </div>
  <!-- End Features Section -->

  <div class="container space-2">
    <div class="row justify-content-md-between">
      <div class="col-sm-6 offset-sm-3 col-lg-4 offset-lg-0 mb-7 mb-lg-0">
        <!-- Figures -->
        <div class="text-center">
          <h3 class="display-2 text-admin-primary font-weight-semi-bold">500k</h3>
          <p>500k conference attendees served</p>
        </div>
        <!-- End Figures -->
      </div>

      <div class="col-sm-6 col-lg-4 mb-7 mb-sm-0">
        <!-- Figures -->
        <div class="text-center">
          <h3 class="display-2 text-admin-primary font-weight-semi-bold">500</h3>
          <p>Over 500 successful conferences</p>
        </div>
        <!-- End Figures -->
      </div>

      <div class="col-sm-6 col-lg-4">
        <!-- Figures -->
        <div class="text-center">
          <h3 class="display-2 text-admin-primary font-weight-semi-bold">325k+</h3>
          <p>CEU certificates issued</p>
        </div>
        <!-- End Figures -->
      </div>
    </div>
  </div>


  <div id="SVGelements" class="">
    <!-- SVG Background -->
    <figure class="position-absolute right-0 bottom-0 left-0">
      <img class="js-svg-injector" src="../../assets/svg/components/wave-1-bottom-sm.svg" alt="Image Description"
           data-parent="#SVGelements">
    </figure>
    <!-- End SVG Background -->

    <div class="gradient-half-primary-v3">
      <div class="container space-top-2 space-top-md-3 space-bottom-1">
        <div class="row justify-content-lg-between align-items-lg-start">
          <div class="col-lg-5 mb-7 mb-lg-0">
            <!-- Title -->
            <div class="pr-md-4 mb-4">
              <h2 class="text-primary">Let's get you <span class="font-weight-semi-bold">started</span></h2>
              <p>Partner with OkWhen and experience the difference that true full-service management delivers. Our seasoned team seamlessly handles every aspect of your event, allowing you to focus on what matters most—connecting with your audience and achieving your goals.</p>
            </div>
            <!-- End Title -->

            <button class="btn btn-soft-primary btn-wide btn-pill transition-3d-hover ml-1 mb-2" type="button" (click)="ctaService.showCTA('17e74dcb-2609-478e-848a-ceffdd2c4df2')">Get Started</button>
          </div>

          <div class="col-lg-6 mt-auto">
            <!-- SVG Icon -->
            <figure class="ie-working-men">
              <img class="js-svg-injector" src="../../assets/svg/illustrations/app-development.svg" alt="SVG Illustration"
                   data-parent="#SVGelements">
            </figure>
            <!-- End SVG Icon -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- End Hero Section -->
<!--  <div class="container space-2">-->
<!--    &lt;!&ndash; Title &ndash;&gt;-->
<!--    <div class="d-sm-flex justify-content-sm-between align-items-sm-center mb-5">-->
<!--      <h2 class="h3 font-weight-medium">{{ 'upcoming-conferences' | translate }}</h2>-->
<!--      <a class="link-muted" [routerLink]="['/conferences']">-->
<!--        {{ 'view-all' | translate }}-->
<!--        <span class="fas fa-angle-right small ml-2"></span>-->
<!--      </a>-->
<!--    </div>-->
<!--    &lt;!&ndash; End Title &ndash;&gt;-->

<!--    <div class="row">-->
<!--      <div *ngIf="!conferences" class="col-md-12">-->
<!--        <p-skeleton width="100%" height="200px"></p-skeleton>-->
<!--      </div>-->
<!--      <div *ngIf="conferences" class="col-md-12">-->
<!--        <p-carousel [numVisible]="4" [numScroll]="1" [value]="conferences" [responsiveOptions]="responsiveOptions">-->
<!--          <ng-template let-conf pTemplate="item">-->
<!--            <bxl-conference-item [conference]="conf" [isGrid]="true"></bxl-conference-item>-->
<!--          </ng-template>-->
<!--        </p-carousel>-->
<!--        &lt;!&ndash; <carousel [height]="420" [cellWidth]="400">-->
<!--          <div *ngFor="let conf of conferences" class="carousel-cell">-->
<!--            <bxl-conference-item [conference]="conf" [isGrid]="true"></bxl-conference-item>-->
<!--          </div>-->
<!--        </carousel> &ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div id="SVGbgElements6" class="position-relative overflow-hidden">-->
<!--    <div class="container">-->
<!--      <div class="d-sm-flex justify-content-sm-between align-items-sm-center mb-5">-->
<!--        <h2 class="h3 font-weight-medium">{{ 'featured-on-demand-content' | translate }}</h2>-->
<!--        <a class="link-muted" [routerLink]="['/course-library']">-->
<!--          {{ 'search-library' | translate }}-->
<!--          <span class="fas fa-angle-right small ml-2"></span>-->
<!--        </a>-->
<!--      </div>-->
<!--      <div class="row">-->
<!--        <div *ngIf="!featuredCourses" class="col-md-12">-->
<!--          <p-skeleton width="100%" height="200px"></p-skeleton>-->
<!--        </div>-->
<!--        <div *ngIf="featuredCourses" class="col-md-12">-->
<!--          <p-carousel [numVisible]="5" [value]="featuredCourses" [responsiveOptions]="responsiveOptions2">-->
<!--            <ng-template let-course pTemplate="item">-->
<!--              <div [routerLink]="['/courses', course.slug]" class="card cursor-pointer">-->
<!--                <bxl-course-item [course]="course" [isGrid]="true"></bxl-course-item>-->
<!--              </div>-->
<!--            </ng-template>-->
<!--          </p-carousel>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->


<!--    <figure class="position-absolute top-0 right-0 z-index-n1 w-100 h-100">-->
<!--      <img class="js-svg-injector" src="../../assets/svg/components/bg-elements-6.svg" alt="SVG" data-parent="#SVGbgElements6" />-->
<!--    </figure>-->
<!--  -->
<!--  </div>-->
</main>
<!-- ========== END MAIN CONTENT ========== -->
<!-- ========== MAIN CONTENT ========== -->

<!-- ========== END MAIN CONTENT ========== -->
